import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import type { StandardContractView } from '../contract-types';
import { ContractHistoryDialog } from '../history/contract-history-dialog';
import { StandardContractTable } from './standard-contract-table';

interface StandardContractsTabProps {
  contracts: StandardContractView[];
  onConfigure: (contract: StandardContractView) => void;
  onEdit: (contract: StandardContractView) => void;
  onPublishVersion: (contract: StandardContractView) => void;
}

export function StandardContractsTab({
  contracts,
  onConfigure,
  onEdit,
  onPublishVersion,
}: StandardContractsTabProps) {
  const [historyTarget, setHistoryTarget] = useState<StandardContractView | null>(null);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Contratos Padrões</CardTitle>
        <CardDescription>
          Configure os modelos base utilizados na geração de contratos para clientes.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <StandardContractTable
          contracts={contracts}
          onConfigure={onConfigure}
          onEdit={onEdit}
          onShowHistory={(contract) => setHistoryTarget(contract)}
          onPublishVersion={onPublishVersion}
        />
      </CardContent>

      <ContractHistoryDialog
        open={historyTarget !== null}
        onOpenChange={(open) => {
          if (!open) setHistoryTarget(null);
        }}
        contractLabel={historyTarget?.label ?? ''}
        contractId={historyTarget?.contractId ?? null}
      />
    </Card>
  );
}
